import type { CommentThreadFragment } from "generated-graphql/graphql";

import { useMutation } from "@apollo/client";
import { useAlerts } from "components/Alerts/AlertProvider";
import { GenericCommentStream } from "components/Comments/GenericCommentStream";
import { useEffect, useState } from "react";

import { ADD_CREDENTIAL_IMPLEMENTATION_COMMENT } from "../api";
import { DrawerSection } from "./DrawerSection";

export function CommentsSection({
  credentialImplementationId,
  comments,
  currentUserId,
}: {
  credentialImplementationId: string;
  comments: CommentThreadFragment[];
  currentUserId?: string;
}) {
  const alerts = useAlerts();
  const [localComments, setLocalComments] = useState(comments);
  const [addComment, { loading }] = useMutation(ADD_CREDENTIAL_IMPLEMENTATION_COMMENT);

  useEffect(() => {
    setLocalComments(comments);
  }, [comments]);

  const onAddComment = async (message: string) => {
    try {
      const result = await addComment({
        variables: { credentialImplementationId, comment: message },
      });
      const savedComment = result.data?.addCredentialImplementationComment;
      if (savedComment) {
        setLocalComments((existing) => [savedComment, ...existing]);
      }
    } catch (e) {
      alerts.error("Could not add comment", e);
      throw e;
    }
  };

  return (
    <DrawerSection title="Comments">
      <GenericCommentStream
        title=""
        comments={localComments}
        currentUserId={currentUserId}
        onAddComment={onAddComment}
        addLoading={loading}
        emptyStateMessage="No comments yet."
        placeholder="Add a comment…"
      />
    </DrawerSection>
  );
}
